export default __webpack_public_path__ + "static/media/error_tick.932e7154.svg";